module.exports = __webpack_public_path__ + "static/assets/3682b35e452a7f4a5a61167d1632e24a.ttf";